export interface PeekingAssistantState {
  disabled: boolean;
  fund_type: 'fund' | 'rfp';
}

export const initialPeekingAssistantState: PeekingAssistantState = {
  disabled: false,
  fund_type: 'fund',
};
